module.exports = __webpack_public_path__ + "img/icon-dropdown.fa26e9f9.svg";